import React from 'react';

import { PanelBlock } from '@molecules/panelBlock/PanelBlock';

export const LocateProductTemplate = () => {
    return (
        <PanelBlock
            title="Locate Product"
            hideHeaderOnMobile={false}
            withDivider
            fullWidth={false}
            fullHeight={false}
            isFullWidthOnSmallDesktop
        >
            {/* content */}
        </PanelBlock>
    );
};
